'use strict';
import * as $i_cytoscape from "cytoscape";
import * as $i_cytoscape$002ddagre from "cytoscape-dagre";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_js\uff3ffacades_Cytoscape$() {
  $n_Lapp_js\uff3ffacades_Cytoscape$ = this;
  $i_cytoscape.default.use($i_cytoscape$002ddagre.default);
}
export { $c_Lapp_js\uff3ffacades_Cytoscape$ as $c_Lapp_js\uff3ffacades_Cytoscape$ };
$p = $c_Lapp_js\uff3ffacades_Cytoscape$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_js\uff3ffacades_Cytoscape$;
/** @constructor */
function $h_Lapp_js\uff3ffacades_Cytoscape$() {
}
export { $h_Lapp_js\uff3ffacades_Cytoscape$ as $h_Lapp_js\uff3ffacades_Cytoscape$ };
$h_Lapp_js\uff3ffacades_Cytoscape$.prototype = $p;
$p.bGg = (function(opts) {
  return (0, $i_cytoscape.default)(opts);
});
var $d_Lapp_js\uff3ffacades_Cytoscape$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_js\uff3ffacades_Cytoscape$, "app.js_facades.Cytoscape$", ({
  GT: 1
}));
export { $d_Lapp_js\uff3ffacades_Cytoscape$ as $d_Lapp_js\uff3ffacades_Cytoscape$ };
var $n_Lapp_js\uff3ffacades_Cytoscape$;
function $m_Lapp_js\uff3ffacades_Cytoscape$() {
  if ((!$n_Lapp_js\uff3ffacades_Cytoscape$)) {
    $n_Lapp_js\uff3ffacades_Cytoscape$ = new $c_Lapp_js\uff3ffacades_Cytoscape$();
  }
  return $n_Lapp_js\uff3ffacades_Cytoscape$;
}
export { $m_Lapp_js\uff3ffacades_Cytoscape$ as $m_Lapp_js\uff3ffacades_Cytoscape$ };
//# sourceMappingURL=app.js_facades.-Cytoscape$.js.map
